import {formsStore} from '../../../stores/Form';

export const mayDesignForm = () => {
    return !!formsStore?.sysConstants?.maydesignform?.Boolean;
};
